import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n17 = 0, F = function F() {}; return { s: F, n: function n() { return _n17 >= r.length ? { done: !0 } : { done: !1, value: r[_n17++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*! License details at fancyapps.com/license */
import { isPlainObject as e } from "../utils/isPlainObject.js";
import { isNode as t } from "../utils/isNode.js";
import { isString as n } from "../utils/isString.js";
import { getScrollableParent as i } from "../utils/getScrollableParent.js";
import { getDirectChildren as o } from "../utils/getDirectChildren.js";
import { extend as s } from "../utils/extend.js";
import { map as r } from "../utils/map.js";
import { stringToHtml as l } from "../utils/strToHtml.js";
import { clamp as a } from "../utils/clamp.js";
import { addClass as c } from "../utils/addClass.js";
import { removeClass as d } from "../utils/removeClass.js";
import { toggleClass as u } from "../utils/toggleClass.js";
import { Tween as f } from "../libs/tween.js";
import { Gestures as v } from "../libs/gestures.js";
import { en_EN as p } from "./l10n/en_EN.js";
var g = function g(e) {
    e.cancelable && e.preventDefault();
  },
  m = {
    adaptiveHeight: !1,
    center: !0,
    classes: {
      container: "f-carousel",
      isEnabled: "is-enabled",
      isLTR: "is-ltr",
      isRTL: "is-rtl",
      isHorizontal: "is-horizontal",
      isVertical: "is-vertical",
      hasAdaptiveHeight: "has-adaptive-height",
      viewport: "f-carousel__viewport",
      slide: "f-carousel__slide",
      isSelected: "is-selected"
    },
    dragFree: !1,
    enabled: !0,
    errorTpl: '<div class="f-html">{{ERROR}}</div>',
    fill: !1,
    infinite: !0,
    initialPage: 0,
    l10n: p,
    rtl: !1,
    slides: [],
    slidesPerPage: "auto",
    spinnerTpl: '<div class="f-spinner"></div>',
    transition: "fade",
    tween: {
      clamp: !0,
      mass: 1,
      tension: 160,
      friction: 25,
      restDelta: 1,
      restSpeed: 1,
      velocity: 0
    },
    vertical: !1
  };
var h,
  b = 0;
var _E = function E(p) {
  var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  b++;
  var w,
    M,
    S,
    j,
    P,
    L = 0,
    A = Object.assign({}, m),
    O = Object.assign({}, m),
    T = {},
    R = null,
    V = null,
    C = !1,
    H = !1,
    D = !1,
    $ = !1,
    z = "height",
    q = 0,
    F = !0,
    I = 0,
    k = 0,
    B = 0,
    N = 0,
    _ = "*",
    G = [],
    X = [];
  var Y = new Set();
  var W = [],
    J = [],
    K = 0,
    Q = 0,
    U = 0;
  function Z(e) {
    var n = O[e];
    for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      t[_key - 1] = arguments[_key];
    }
    return n && n instanceof Function ? n.apply(void 0, [He].concat(t)) : n;
  }
  function ee(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var n = Z("l10n") || {};
    e = String(e).replace(/\{\{(\w+)\}\}/g, function (e, t) {
      return n[t] || e;
    });
    for (var _n = 0; _n < t.length; _n++) e = e.split(t[_n][0]).join(t[_n][1]);
    return e = e.replace(/\{\{(.*?)\}\}/g, function (e, t) {
      return t;
    });
  }
  var te = new Map();
  function ne(e) {
    var n = _toConsumableArray(te.get(e) || []);
    O.on && n.push(O.on[e]);
    for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      t[_key2 - 1] = arguments[_key2];
    }
    var _iterator = _createForOfIteratorHelper(n),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _e = _step.value;
        _e && _e instanceof Function && _e.apply(void 0, [He].concat(t));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    "*" !== e && ne.apply(void 0, ["*", e].concat(t));
  }
  function ie() {
    var t, n;
    var i = s({}, m, A);
    s(i, m, A);
    var r = "";
    var l = A.breakpoints || {};
    if (l) for (var _i = 0, _Object$entries = Object.entries(l); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        _e2 = _Object$entries$_i[0],
        _t = _Object$entries$_i[1];
      window.matchMedia(_e2).matches && (r += _e2, s(i, _t));
    }
    if (void 0 === P || r !== P) {
      if (P = r, 0 !== L) {
        var _e3 = null === (n = null === (t = J[I]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === n ? void 0 : n.index;
        void 0 === _e3 && (_e3 = O.initialSlide), i.initialSlide = _e3, i.slides = [];
        var _iterator2 = _createForOfIteratorHelper(G),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _e4 = _step2.value;
            _e4.isVirtual && i.slides.push(_e4);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      Re(), O = i, !1 !== O.enabled && (L = 0, ne("init"), function () {
        for (var _i2 = 0, _Object$entries2 = Object.entries(Object.assign(Object.assign({}, y), O.plugins || {})); _i2 < _Object$entries2.length; _i2++) {
          var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
            _e5 = _Object$entries2$_i[0],
            _t2 = _Object$entries2$_i[1];
          if (_e5 && !T[_e5] && _t2 instanceof Function) {
            var _n2 = _t2();
            _n2.init(He, _E), T[_e5] = _n2;
          }
        }
        ne("initPlugins");
      }(), function (_V) {
        if (!R) return;
        var t = Z("classes") || {};
        c(R, t.container);
        var n = Z("style");
        if (n && e(n)) for (var _i3 = 0, _Object$entries3 = Object.entries(n); _i3 < _Object$entries3.length; _i3++) {
          var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
            _e6 = _Object$entries3$_i[0],
            _t3 = _Object$entries3$_i[1];
          R.style.setProperty(_e6, _t3);
        }
        V = R.querySelector(".".concat(t.viewport)), V || (V = document.createElement("div"), c(V, t.viewport), (_V = V).append.apply(_V, _toConsumableArray(o(R, ".".concat(t.slide)))), R.insertAdjacentElement("afterbegin", V)), R.carousel = He, ne("initLayout");
      }(), function () {
        if (!V) return;
        var e = Z("classes") || {};
        G = [], _toConsumableArray(o(V, ".".concat(e.slide))).forEach(function (e) {
          e.parentElement && G.push(me(Object.assign({
            el: e,
            isVirtual: !1
          }, e.dataset || {})));
        }), ge(Z("slides"));
        for (var _i4 = 0, _G = G; _i4 < _G.length; _i4++) {
          var _e7 = _G[_i4];
          ne("addSlide", _e7);
        }
        for (var _i5 = 0, _G2 = G; _i5 < _G2.length; _i5++) {
          var _e8 = _G2[_i5];
          var _t4 = _e8.el;
          (null == _t4 ? void 0 : _t4.parentElement) && (c(_t4, O.classes.slide), c(_t4, _e8.class), Ae(_e8), ne("attachSlideEl", _e8));
        }
        ne("initSlides");
      }(), ye(), function () {
        if (R && (R.addEventListener("click", je, {
          passive: !1
        }), document.addEventListener("mousemove", oe), !S)) {
          var _e9 = null;
          S = new ResizeObserver(function (t) {
            _e9 || (_e9 = requestAnimationFrame(function () {
              !function (e) {
                var t;
                if (!R) return;
                if (0 === L) {
                  var _n3 = null === (t = e[0]) || void 0 === t ? void 0 : t.contentBoxSize[0],
                    _i6 = (null == _n3 ? void 0 : _n3.blockSize) || 0,
                    _o = (null == _n3 ? void 0 : _n3.inlineSize) || 0;
                  return K = _i6, Q = _o, L = 1, c(R, (Z("classes") || {}).isEnabled), Te(), M = f().on("start", function () {
                    w && w.isPointerDown() || (le(), Te());
                  }).on("step", function (e) {
                    var t = q;
                    q = e.pos, q !== t && (F = !1, Te());
                  }).on("end", function (e) {
                    (null == w ? void 0 : w.isPointerDown()) || (q = e.pos, M && !H && (q < B || q > N) ? M.spring({
                      clamp: !0,
                      mass: 1,
                      tension: 200,
                      friction: 25,
                      velocity: 0,
                      restDelta: 1,
                      restSpeed: 1
                    }).from({
                      pos: q
                    }).to({
                      pos: a(B, q, N)
                    }).start() : F || (F = !0, ne("settle")));
                  }), se(), ae(), void ne("ready");
                }
                if (1 !== L) return;
                var n = J.length;
                ye(), se();
                var i = R.getBoundingClientRect(),
                  o = i.height,
                  s = i.width;
                n > 1 && ($ && Math.abs(o - K) < .5 || !$ && Math.abs(s - Q) < .5) || (K = o, Q = s, $ && !o || !$ && !s || R && V && (n === J.length && (null == w ? void 0 : w.isPointerDown()) || (Z("dragFree") && (H || q > B && q < N) ? (le(), Te()) : Oe(I, {
                  transition: !1
                }))));
              }(t), _e9 = null;
            }));
          }), S.observe(R);
        }
      }());
    }
  }
  function oe(e) {
    h = e;
  }
  function se() {
    if (!V) return;
    var e = Z("gestures");
    !1 !== e ? w || (w = v(V, e).on("start", function (e) {
      var t, n;
      if (!M) return;
      var o = e.srcEvent;
      $ && i(o.target), M.pause(), M.getCurrentVelocities().pos = 0;
      var s = null === (t = J[I]) || void 0 === t ? void 0 : t.slides[0];
      if (s && Y.has(s.index) && s.el && (q = s.offset || 0, q += (function (e) {
        var t = window.getComputedStyle(e),
          n = new DOMMatrixReadOnly(t.transform);
        return {
          width: n.m41 || 0,
          height: n.m42 || 0
        };
      }(s.el)[z] || 0) * (D && !$ ? 1 : -1)), Me(), !H) {
        (q < B || q > N) && M.spring({
          clamp: !0,
          mass: 1,
          tension: 500,
          friction: 25,
          velocity: (null === (n = M.getCurrentVelocities()) || void 0 === n ? void 0 : n.pos) || 0,
          restDelta: 1,
          restSpeed: 1
        }).from({
          pos: q
        }).to({
          pos: a(B, q, N)
        }).start();
      }
    }).on("move", function (e) {
      var t = e.srcEvent,
        n = e.axis,
        o = e.srcEvent.target;
      o && i(o) || (n || (t.stopPropagation(), t.stopImmediatePropagation()), ("y" === n && $ || "x" === n && !$) && (g(t), t.stopPropagation()));
    }).on("panstart", function (e) {
      (null == e ? void 0 : e.axis) === ($ ? "y" : "x") && c(V, "is-dragging");
    }).on("panend", function () {
      d(V, "is-dragging");
    }).on("pan", function (e) {
      var t;
      var n = e.deltaX,
        i = e.deltaY,
        o = e.currentTouch,
        s = e.axis;
      if (!M) return;
      if (o.length > 1) return;
      if ("y" === s && !$ || "x" === s && $) return;
      var r = D && !$ ? 1 : -1;
      var l = $ ? i : n,
        a = (null == M ? void 0 : M.isRunning()) ? M.getEndValues().pos : q,
        c = 1;
      H || (a <= B && l * r < 0 ? (c = Math.max(.01, 1 - Math.abs(1 / fe() * Math.abs(a - B))), c *= .2) : a >= N && l * r > 0 && (c = Math.max(.01, 1 - Math.abs(1 / fe() * Math.abs(a - N))), c *= .2)), a += l * c * r, M.spring({
        clamp: !0,
        mass: 1,
        tension: 700,
        friction: 25,
        velocity: (null === (t = M.getCurrentVelocities()) || void 0 === t ? void 0 : t.pos) || 0,
        restDelta: 1,
        restSpeed: 1
      }).from({
        pos: q
      }).to({
        pos: a
      }).start();
    }).on("end", function (e) {
      var t, n;
      var i = e.axis,
        o = e.velocityX,
        s = e.velocityY,
        r = e.currentTouch,
        l = J.length,
        c = Z("dragFree");
      if (r.length > 0 || !M) return;
      if (!l) return;
      var d = Z("vertical") ? s : o;
      var u = (null == M ? void 0 : M.isRunning()) ? M.getEndValues().pos : q;
      var f = D && !$ ? 1 : -1;
      if (u += d * (c ? 5 : 1) * f, !H && (d * f <= 0 && u < B || d * f >= 0 && u > N)) {
        var _e10 = 0;
        return Math.abs(d) > 0 && (_e10 = 2 * Math.abs(d), _e10 = Math.min(.3 * fe(), _e10)), u = a(B + -1 * _e10, u, N + _e10), void M.spring({
          clamp: !0,
          mass: 1,
          tension: 380,
          friction: 25,
          velocity: -1 * d,
          restDelta: 1,
          restSpeed: 1
        }).from({
          pos: q
        }).to({
          pos: u
        }).start();
      }
      if (c || (null === (t = T.Autoscroll) || void 0 === t ? void 0 : t.isEnabled())) return void (Math.abs(d) > 10 ? M.spring({
        clamp: !0,
        mass: 1,
        tension: 150,
        friction: 25,
        velocity: -1 * d,
        restDelta: 1,
        restSpeed: 1
      }).from({
        pos: q
      }).to({
        pos: u
      }).start() : M.isRunning() || F || (F = !0, ne("settle")));
      if (!c && !(null === (n = T.Autoscroll) || void 0 === n ? void 0 : n.isEnabled()) && (!e.offsetX && !e.offsetY || "y" === i && !$ || "x" === i && $)) return void Oe(I, {
        transition: "tween"
      });
      var v = de(u);
      Math.abs(d) > 10 && v === I && (v += d > 0 ? D && !$ ? 1 : -1 : D && !$ ? -1 : 1), Oe(v, {
        transition: "tween",
        tween: {
          velocity: -1 * d
        }
      });
    }).init()) : w && (w.destroy(), w = void 0);
  }
  function re() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "*";
    var t;
    var n = [];
    var _iterator3 = _createForOfIteratorHelper(G),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _i7 = _step3.value;
        ("*" === e || _i7.class && _i7.class.includes(e) || _i7.el && (null === (t = _i7.el) || void 0 === t ? void 0 : t.classList.contains(e))) && n.push(_i7);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    j = void 0, _ = e, X = [].concat(n);
  }
  function le() {
    if (!M) return;
    var e = de((null == M ? void 0 : M.isRunning()) ? M.getEndValues().pos : q);
    e !== I && (j = I, I = e, Ae(), ae(), ce(), ne("change", I, j));
  }
  function ae() {
    var e;
    if (!R) return;
    u(V, "is-draggable", !!w && J.length > 0);
    var _iterator4 = _createForOfIteratorHelper(R.querySelectorAll("[data-carousel-index]")),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _e11 = _step4.value;
        _e11.innerHTML = I + "";
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    var _iterator5 = _createForOfIteratorHelper(R.querySelectorAll("[data-carousel-page]")),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var _e12 = _step5.value;
        _e12.innerHTML = I + 1 + "";
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
    var _iterator6 = _createForOfIteratorHelper(R.querySelectorAll("[data-carousel-pages]")),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var _e13 = _step6.value;
        _e13.innerHTML = J.length + "";
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
    var _iterator7 = _createForOfIteratorHelper(R.querySelectorAll("[data-carousel-go-prev]")),
      _step7;
    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var _e14 = _step7.value;
        _e14.toggleAttribute("aria-disabled", !Ve()), Ve() ? _e14.removeAttribute("tabindex") : _e14.setAttribute("tabindex", "-1");
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
    var _iterator8 = _createForOfIteratorHelper(R.querySelectorAll("[data-carousel-go-next]")),
      _step8;
    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var _e15 = _step8.value;
        _e15.toggleAttribute("aria-disabled", !Ce()), Ce() ? _e15.removeAttribute("tabindex") : _e15.setAttribute("tabindex", "-1");
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
    var t = !1;
    var n = null === (e = J[I]) || void 0 === e ? void 0 : e.slides[0];
    n && (n.downloadSrc || "image" === n.type && n.src) && (t = !0);
    var _iterator9 = _createForOfIteratorHelper(R.querySelectorAll("[data-carousel-download]")),
      _step9;
    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var _e16 = _step9.value;
        _e16.toggleAttribute("aria-disabled", !t);
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
  }
  function ce(e) {
    var t;
    e || (e = null === (t = J[I]) || void 0 === t ? void 0 : t.slides[0]);
    var n = e.el;
    if (n) {
      var _iterator10 = _createForOfIteratorHelper(n.querySelectorAll("[data-slide-index]")),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var _t5 = _step10.value;
          _t5.innerHTML = e.index + 1 + "";
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }
  }
  function de(e) {
    var t, n, i;
    if (!J.length || !M) return 0;
    var o = ve();
    var s = e;
    H ? s -= Math.floor((e - (null === (t = J[0]) || void 0 === t ? void 0 : t.pos)) / o) * o : s = a(null === (n = J[0]) || void 0 === n ? void 0 : n.pos, e, null === (i = J[J.length - 1]) || void 0 === i ? void 0 : i.pos);
    var r = new Map();
    var l = 0;
    var _iterator11 = _createForOfIteratorHelper(J),
      _step11;
    try {
      for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
        var _e17 = _step11.value;
        var _t6 = Math.abs(_e17.pos - s),
          _n4 = Math.abs(_e17.pos - s - o),
          _i8 = Math.abs(_e17.pos - s + o),
          _a = Math.min(_t6, _n4, _i8);
        r.set(l, _a), l++;
      }
    } catch (err) {
      _iterator11.e(err);
    } finally {
      _iterator11.f();
    }
    var c = r.size > 0 ? _toConsumableArray(r.entries()).reduce(function (e, t) {
      return t[1] < e[1] ? t : e;
    }) : [I, 0];
    return parseInt(c[0]);
  }
  function ue() {
    return U;
  }
  function fe() {
    return V && V.getBoundingClientRect()[z] || 0;
  }
  function ve() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
    return X.reduce(function (e, t) {
      return e + t.dim;
    }, 0) + (X.length - (H && e ? 0 : 1)) * U;
  }
  function pe(e) {
    var t = ve();
    var n = fe();
    if (!V) return [];
    var i = [];
    if (!t || !n) return [];
    e = void 0 === e ? q : e, H && (e -= Math.floor(e / t) * t);
    var o = 0,
      s = 0;
    if (C) {
      var _e18 = V.getBoundingClientRect();
      o = Math.abs(_e18.left), s = Math.abs(window.innerWidth - _e18.right);
    }
    var r = 0;
    var _iterator12 = _createForOfIteratorHelper(X),
      _step12;
    try {
      var _loop = function _loop() {
        var l = _step12.value;
        var a = function a() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          i.indexOf(l) > -1 || (l.pos = r - e + t || 0, l.offset + t > e - l.dim - o + .51 && l.offset + t < e + n + s - .51 && i.push(l));
        };
        l.offset = r, H && (a(t), a(-1 * t)), a(), r += l.dim + U;
      };
      for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator12.e(err);
    } finally {
      _iterator12.f();
    }
    return i;
  }
  function ge(e, t) {
    var _G3;
    var n = [];
    var _iterator13 = _createForOfIteratorHelper(Array.isArray(e) ? e : [e]),
      _step13;
    try {
      for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
        var _t7 = _step13.value;
        var _e20 = me(Object.assign(Object.assign({}, _t7), {
          isVirtual: !0
        }));
        n.push(_e20);
      }
    } catch (err) {
      _iterator13.e(err);
    } finally {
      _iterator13.f();
    }
    (_G3 = G).splice.apply(_G3, [void 0 === t ? G.length : t, 0].concat(n)), xe();
    for (var _i9 = 0, _n5 = n; _i9 < _n5.length; _i9++) {
      var _e19 = _n5[_i9];
      he(_e19);
    }
    return re(_), n;
  }
  function me(e) {
    return (n(e) || e instanceof HTMLElement) && (e = {
      html: e
    }), Object.assign({
      index: -1,
      el: void 0,
      class: "",
      isVirtual: !0,
      dim: 0,
      pos: 0,
      offset: 0,
      html: "",
      src: ""
    }, e);
  }
  function he(e) {
    if (!e) return;
    var t = e.el;
    t || (t = document.createElement("div"), e.el = t);
    var n = e.html ? e.html instanceof HTMLElement ? e.html : l(e.html) : void 0;
    n && (c(n, "f-html"), e.htmlEl = n, c(t, "has-html"), t.append(n), ne("contentReady", e));
  }
  function be(e) {
    if (!V || !e) return;
    var t = e.el;
    if (t) {
      if (t.setAttribute("index", e.index + ""), t.parentElement !== V) {
        var _n6;
        c(t, O.classes.slide), c(t, e.class), Ae(e);
        var _iterator14 = _createForOfIteratorHelper(G),
          _step14;
        try {
          for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
            var _t8 = _step14.value;
            if (_t8.index > e.index) {
              _n6 = _t8.el;
              break;
            }
          }
        } catch (err) {
          _iterator14.e(err);
        } finally {
          _iterator14.f();
        }
        V.insertBefore(t, _n6 && V.contains(_n6) ? _n6 : null), ne("attachSlideEl", e);
      }
      return ce(e), t;
    }
  }
  function Ee(e) {
    var t = null == e ? void 0 : e.el;
    t && (t.remove(), we(t), ne("detachSlideEl", e));
  }
  function xe() {
    for (var _e21 = 0; _e21 < G.length; _e21++) {
      var _t9 = G[_e21],
        _n7 = _t9.el;
      _n7 && (_t9.index !== _e21 && we(_n7), _n7.setAttribute("index", "".concat(_e21))), _t9.index = _e21;
    }
  }
  function ye() {
    var e, n, i, o, s;
    if (!R || !V) return;
    D = Z("rtl"), $ = Z("vertical"), z = $ ? "height" : "width";
    var r = Z("classes");
    u(R, r.isLTR, !D), u(R, r.isRTL, D), u(R, r.isHorizontal, !$), u(R, r.isVertical, $), u(R, r.hasAdaptiveHeight, Z("adaptiveHeight")), C = "visible" === window.getComputedStyle(V).getPropertyValue("overflow-" + ($ ? "y" : "x"));
    var l = V.getBoundingClientRect();
    if (!l.width && !l.height) return;
    U = V && parseFloat(getComputedStyle(V).getPropertyValue("--f-carousel-gap")) || 0;
    var d = function () {
      var e = 0;
      if (V) {
        var _t10 = document.createElement("div");
        c(_t10, O.classes.slide), V.appendChild(_t10), e = _t10.getBoundingClientRect()[z], _t10.remove(), _t10 = void 0;
      }
      return e;
    }();
    var _iterator15 = _createForOfIteratorHelper(X),
      _step15;
    try {
      for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
        var _n9 = _step15.value;
        var _i13 = _n9.el;
        var _o3 = 0;
        if (!_n9.isVirtual && _i13 && t(_i13)) {
          var _t14 = !1;
          _i13.parentElement && _i13.parentElement === V || (V.appendChild(_i13), _t14 = !0), _o3 = _i13.getBoundingClientRect()[z], _t14 && (null === (e = _i13.parentElement) || void 0 === e || e.removeChild(_i13));
        } else _o3 = d;
        _n9.dim = _o3;
      }
    } catch (err) {
      _iterator15.e(err);
    } finally {
      _iterator15.f();
    }
    if (H = !1, Z("infinite")) {
      H = !0;
      var _e22 = ve();
      var _t11 = fe();
      if (C) {
        var _e23 = V.getBoundingClientRect();
        _t11 += _e23.left, _t11 += _e23.right - _e23.width;
      }
      for (var _i10 = 0; _i10 < X.length; _i10++) {
        var _o2 = (null === (n = X[_i10]) || void 0 === n ? void 0 : n.dim) + U;
        if (_e22 - _o2 < _t11 && _e22 - _o2 - _t11 < _o2) {
          H = !1;
          break;
        }
      }
    }
    if (function () {
      var e;
      if (!R) return;
      xe();
      var t = fe(),
        n = ve(!1);
      var i = Z("slidesPerPage");
      i = "auto" === i ? 1 / 0 : parseFloat(i + ""), J = [];
      var o = 0,
        s = 0;
      var _iterator16 = _createForOfIteratorHelper(X),
        _step16;
      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var _n8 = _step16.value;
          (!J.length || o + _n8.dim - t > .05 || s >= i) && (J.push({
            index: J.length,
            slides: [],
            dim: 0,
            offset: 0,
            pos: 0
          }), o = 0, s = 0), null === (e = J[J.length - 1]) || void 0 === e || e.slides.push(_n8), o += _n8.dim + U, s++;
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }
      var r = Z("center"),
        l = Z("fill");
      var c = 0;
      for (var _i11 = 0, _J = J; _i11 < _J.length; _i11++) {
        var _e24 = _J[_i11];
        _e24.dim = (_e24.slides.length - 1) * U;
        var _iterator17 = _createForOfIteratorHelper(_e24.slides),
          _step17;
        try {
          for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
            var _t12 = _step17.value;
            _e24.dim += _t12.dim;
          }
        } catch (err) {
          _iterator17.e(err);
        } finally {
          _iterator17.f();
        }
        _e24.offset = c, _e24.pos = c, !1 !== r && (_e24.pos -= .5 * (t - _e24.dim)), l && !H && n > t && (_e24.pos = a(0, _e24.pos, n - t)), c += _e24.dim + U;
      }
      var d = [];
      var u;
      for (var _i12 = 0, _J2 = J; _i12 < _J2.length; _i12++) {
        var _e25 = _J2[_i12];
        var _t13 = Object.assign({}, _e25);
        u && Math.abs(_t13.pos - u.pos) < .1 ? (u.dim += _t13.dim, u.slides = [].concat(_toConsumableArray(u.slides), _toConsumableArray(_t13.slides))) : (u = _t13, _t13.index = d.length, d.push(_t13));
      }
      J = d, ae();
    }(), B = (null === (i = J[0]) || void 0 === i ? void 0 : i.pos) || 0, N = (null === (o = J[J.length - 1]) || void 0 === o ? void 0 : o.pos) || 0, 0 === L) !function () {
      var e;
      j = void 0, I = Z("initialPage");
      var t = Z("initialSlide") || void 0;
      void 0 !== t && (I = He.getPageIndex(t) || 0), I = a(0, I, J.length - 1), q = (null === (e = J[I]) || void 0 === e ? void 0 : e.pos) || 0, k = q;
    }();else {
      var _e26 = (null == M ? void 0 : M.isRunning()) ? M.getEndValues().pos : q;
      (_e26 < B || _e26 > N) && (I = a(0, I, J.length - 1), k = (null === (s = J[I || 0]) || void 0 === s ? void 0 : s.pos) || 0);
    }
    ne("refresh");
  }
  function we(e) {
    if (!e || !t(e)) return;
    var n = parseInt(e.getAttribute("index") || "-1");
    var i = "";
    for (var _i14 = 0, _Array$from = Array.from(e.classList); _i14 < _Array$from.length; _i14++) {
      var _t15 = _Array$from[_i14];
      var _e27 = _t15.match(/^f-(\w+)(Out|In)$/);
      _e27 && _e27[1] && (i = _e27[1] + "");
    }
    if (!e || !i) return;
    var o = ["f-".concat(i, "Out"), "f-".concat(i, "In"), "to-prev", "to-next", "from-prev", "from-next"];
    e.removeEventListener("animationend", Se), d(e, o.join(" ")), Y.delete(n);
  }
  function Me() {
    if (!V) return;
    var e = Y.size;
    var _iterator18 = _createForOfIteratorHelper(X),
      _step18;
    try {
      for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
        var _e28 = _step18.value;
        we(_e28.el);
      }
    } catch (err) {
      _iterator18.e(err);
    } finally {
      _iterator18.f();
    }
    Y.clear(), e && Te();
  }
  function Se(e) {
    "f-" === e.animationName.substring(0, 2) && (we(e.target), Y.size || (d(R, "in-transition"), !F && Math.abs(He.getPosition(!0) - k) < .5 && (F = !0, ne("settle"))), Te());
  }
  function je(e) {
    var t;
    if (e.defaultPrevented) return;
    var n = e.composedPath()[0];
    if (n.closest("[data-carousel-go-prev]")) return g(e), void He.prev();
    if (n.closest("[data-carousel-go-next]")) return g(e), void He.next();
    var i = n.closest("[data-carousel-go-to]");
    if (i) return g(e), void He.goTo(parseFloat(i.dataset.carouselGoTo || "") || 0);
    if (n.closest("[data-carousel-download]")) {
      g(e);
      var _n10 = null === (t = J[I]) || void 0 === t ? void 0 : t.slides[0];
      if (_n10 && (_n10.downloadSrc || "image" === _n10.type && _n10.src)) {
        var _e29 = _n10.downloadFilename,
          _t16 = document.createElement("a"),
          _i15 = _n10.downloadSrc || _n10.src || "";
        _t16.href = _i15, _t16.target = "_blank", _t16.download = _e29 || _i15, _t16.click();
      }
    } else ne("click", e);
  }
  function Pe(e) {
    var t;
    var n = e.el;
    n && (null === (t = n.querySelector(".f-spinner")) || void 0 === t || t.remove());
  }
  function Le(e) {
    var t;
    var n = e.el;
    n && (null === (t = n.querySelector(".f-html.is-error")) || void 0 === t || t.remove(), d(n, "has-error"));
  }
  function Ae(e) {
    var t;
    e || (e = null === (t = J[I]) || void 0 === t ? void 0 : t.slides[0]);
    var i = null == e ? void 0 : e.el;
    if (!i) return;
    var o = Z("formatCaption", e);
    void 0 === o && (o = e.caption), o = o || "";
    var s = Z("captionEl");
    if (s && s instanceof HTMLElement) {
      if (e.index !== I) return;
      if (n(o) && (s.innerHTML = ee(o + "")), o instanceof HTMLElement) {
        if (o.parentElement === s) return;
        s.innerHTML = "", o.parentElement && (o = o.cloneNode(!0)), s.append(o);
      }
      return;
    }
    if (!o) return;
    var r = e.captionEl || i.querySelector(".f-caption");
    !r && o instanceof HTMLElement && o.classList.contains("f-caption") && (r = o), r || (r = document.createElement("div"), c(r, "f-caption"), n(o) ? r.innerHTML = ee(o + "") : o instanceof HTMLElement && (o.parentElement && (o = o.cloneNode(!0)), r.append(o)));
    var l = "f-caption-".concat(b, "_").concat(e.index);
    r.setAttribute("id", l), r.dataset.selectable = "true", c(i, "has-caption"), i.setAttribute("aria-labelledby", l), e.captionEl = r, i.insertAdjacentElement("beforeend", r);
  }
  function Oe(t) {
    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var o, r;
    var _Object$assign = Object.assign({
        transition: O.transition,
        tween: O.tween
      }, i || {}),
      l = _Object$assign.transition,
      u = _Object$assign.tween;
    if (!R || !M) return;
    var f = J.length;
    if (!f) return;
    if (function (e, t) {
      var i, o, s, r;
      if (!(R && M && t && n(t) && "tween" !== t)) return !1;
      if ((null === (i = J[I]) || void 0 === i ? void 0 : i.slides.length) > 1) return !1;
      var l = J.length;
      var u = e > I ? 1 : -1;
      e = H ? (e % l + l) % l : a(0, e, l - 1), D && (u *= -1);
      var f = null === (o = J[I]) || void 0 === o ? void 0 : o.slides[0],
        v = null == f ? void 0 : f.index,
        p = null === (s = J[e]) || void 0 === s ? void 0 : s.slides[0],
        g = null == p ? void 0 : p.index,
        m = null === (r = J[e]) || void 0 === r ? void 0 : r.pos;
      if (void 0 === g || void 0 === v || v === g || q === m || Math.abs(fe() - ((null == p ? void 0 : p.dim) || 0)) > 1) return !1;
      F = !1, M.pause(), Me(), c(R, "in-transition"), q = k = m;
      var h = be(f),
        b = be(p);
      return le(), h && (Y.add(v), h.style.transform = "", h.addEventListener("animationend", Se), d(h, O.classes.isSelected), h.inert = !1, c(h, "f-".concat(t, "Out to-").concat(u > 0 ? "next" : "prev"))), b && (Y.add(g), b.style.transform = "", b.addEventListener("animationend", Se), c(b, O.classes.isSelected), b.inert = !1, c(b, "f-".concat(t, "In from-").concat(u > 0 ? "prev" : "next"))), Te(), !0;
    }(t, l)) return;
    t = H ? (t % f + f) % f : a(0, t, f - 1), k = (null === (o = J[t || 0]) || void 0 === o ? void 0 : o.pos) || 0;
    var v = M.isRunning() ? M.getEndValues().pos : q;
    if (Math.abs(k - v) < 1) return q = k, I !== t && (Ae(), ae(), ce(), j = I, I = t, ne("change", I, j)), Te(), void (F || (F = !0, ne("settle")));
    if (M.pause(), Me(), H) {
      var _e30 = ve(),
        _t17 = Math.floor((v - (null === (r = J[0]) || void 0 === r ? void 0 : r.pos)) / _e30),
        _n11 = k + _t17 * _e30;
      k = [_n11 + _e30, _n11, _n11 - _e30].reduce(function (e, t) {
        return Math.abs(t - v) < Math.abs(e - v) ? t : e;
      });
    }
    !1 !== l && e(u) ? M.spring(s({}, O.tween, u)).from({
      pos: q
    }).to({
      pos: k
    }).start() : (q = k, le(), Te(), F || (F = !0, ne("settle")));
  }
  function Te() {
    var e;
    if (!R || !V) return;
    var t = J[I];
    W = pe();
    var n = new Set();
    var i;
    var s = [];
    var _iterator19 = _createForOfIteratorHelper(X),
      _step19;
    try {
      for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
        var _o4 = _step19.value;
        if (_o4.isVirtual && !Y.has(_o4.index) && W.indexOf(_o4) < 0) continue;
        var _r = be(_o4);
        if (!_r) continue;
        s.push(_o4);
        var _l = (null === (e = null == t ? void 0 : t.slides) || void 0 === e ? void 0 : e.indexOf(_o4)) > -1;
        if (_l && n.add(_r), Z("adaptiveHeight") && _l) {
          var _e31 = (_r.firstElementChild || _r).getBoundingClientRect().height;
          i = null == i ? _e31 : Math.max(i, _e31);
        }
      }
    } catch (err) {
      _iterator19.e(err);
    } finally {
      _iterator19.f();
    }
    V && i && (V.style.height = "".concat(i, "px")), _toConsumableArray(o(V, ".".concat(O.classes.slide))).forEach(function (e) {
      var t = parseInt(e.getAttribute("index") || "-1"),
        i = G[t];
      i || e.remove();
      var o = n.has(e);
      if (u(e, O.classes.isSelected, o), e.inert = W.indexOf(i) < 0, i.isVirtual && !Y.has(i.index) && W.indexOf(i) < 0) return void Ee(i);
      var s = i.pos ? Math.round(1e4 * i.pos) / 1e4 : 0,
        l = 0,
        a = 0,
        c = 0,
        d = 0,
        f = O.setTransform || void 0;
      Y.has(i.index) || (l = $ ? 0 : D ? -1 * s : s, a = $ ? s : 0, c = r(l, 0, i.dim, 0, 100), d = r(a, 0, i.dim, 0, 100)), f instanceof Function && !Y.has(i.index) ? f(He, i, {
        x: l,
        y: a,
        xPercent: c,
        yPercent: d
      }) : e.style.transform = l || a ? "translate3d(".concat(c, "%, ").concat(d, "%,0)") : "";
    }), ne("render", s);
  }
  function Re() {
    var e;
    null == R || R.removeEventListener("click", je), Me(), document.removeEventListener("mousemove", oe), null == S || S.disconnect(), S = void 0;
    var _iterator20 = _createForOfIteratorHelper(G),
      _step20;
    try {
      for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
        var _n12 = _step20.value;
        _n12.el && t(_n12.el) && (_n12.state = void 0, Pe(_n12), Le(_n12), Ee(_n12), _n12.isVirtual ? (null === (e = _n12.el) || void 0 === e || e.remove(), _n12.el = void 0) : (_n12.el.style.transform = "", null == V || V.appendChild(_n12.el)));
      }
    } catch (err) {
      _iterator20.e(err);
    } finally {
      _iterator20.f();
    }
    for (var _i16 = 0, _Object$values = Object.values(T); _i16 < _Object$values.length; _i16++) {
      var _e32 = _Object$values[_i16];
      null == _e32 || _e32.destroy();
    }
    T = {}, null == w || w.destroy(), w = void 0, null == M || M.destroy(), M = void 0;
    for (var _i17 = 0, _Object$entries4 = Object.entries(O.classes || {}); _i17 < _Object$entries4.length; _i17++) {
      var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i17], 2),
        _e33 = _Object$entries4$_i[0],
        _t18 = _Object$entries4$_i[1];
      "container" !== _e33 && d(R, _t18);
    }
    d(V, "is-draggable");
  }
  function Ve() {
    return H || I > 0;
  }
  function Ce() {
    return H || I < J.length - 1;
  }
  var He = {
    add: function add(e, t) {
      var n, i;
      var o = q;
      var s = I,
        r = ve(),
        l = (null == M ? void 0 : M.isRunning()) ? M.getEndValues().pos : q,
        a = Math.floor((l - (null === (n = J[0]) || void 0 === n ? void 0 : n.pos)) / r),
        c = ge(e, t);
      var _iterator21 = _createForOfIteratorHelper(c),
        _step21;
      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var _e34 = _step21.value;
          ne("addSlide", _e34);
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
      return re(_), ye(), M && (s === I && (o -= a * r), k = (null === (i = J[I || 0]) || void 0 === i ? void 0 : i.pos) || 0, o === k ? q = k : M.spring({
        clamp: !0,
        mass: 1,
        tension: 300,
        friction: 25,
        restDelta: 1,
        restSpeed: 1
      }).from({
        pos: o
      }).to({
        pos: k
      }).start()), Te(), He;
    },
    canGoPrev: Ve,
    canGoNext: Ce,
    destroy: function destroy() {
      return ne("destroy"), window.removeEventListener("resize", ie), Re(), te.clear(), R = null, J = [], G = [], O = Object.assign({}, m), T = {}, X = [], P = "", _ = "*", L = 2, He;
    },
    emit: ne,
    filter: function filter() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "*";
      return re(e), ye(), Te(), ne("filter", e), He;
    },
    getContainer: function getContainer() {
      return R;
    },
    getGapDim: ue,
    getGestures: function getGestures() {
      return w;
    },
    getLastMouseMove: function getLastMouseMove() {
      return h;
    },
    getOption: function getOption(e) {
      return Z(e);
    },
    getOptions: function getOptions() {
      return O;
    },
    getPage: function getPage() {
      return J[I];
    },
    getPageIndex: function getPageIndex(e) {
      if (void 0 !== e) {
        for (var _i18 = 0, _arr = J || []; _i18 < _arr.length; _i18++) {
          var _t19 = _arr[_i18];
          var _iterator22 = _createForOfIteratorHelper(_t19.slides),
            _step22;
          try {
            for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
              var _n13 = _step22.value;
              if (_n13.index === e) return _t19.index;
            }
          } catch (err) {
            _iterator22.e(err);
          } finally {
            _iterator22.f();
          }
        }
        return -1;
      }
      return I;
    },
    getPageProgress: function getPageProgress(e, t) {
      var n;
      void 0 === e && (e = I);
      var i = J[e];
      if (!i) return e > I ? -1 : 1;
      var o = ve(),
        s = ue();
      var r = i.pos,
        l = He.getPosition();
      if (H && !0 !== t) {
        var _e35 = Math.floor((l - (null === (n = J[0]) || void 0 === n ? void 0 : n.pos)) / o);
        l -= _e35 * o, r = [r + o, r, r - o].reduce(function (e, t) {
          return Math.abs(t - l) < Math.abs(e - l) ? t : e;
        });
      }
      return (l - r) / (i.dim + s);
    },
    getPageVisibility: function getPageVisibility(e) {
      var t;
      void 0 === e && (e = I);
      var n = J[e];
      if (!n) return e > I ? -1 : 1;
      var i = He.getPosition(),
        o = fe();
      var s = n.pos;
      if (H) {
        var _e36 = He.getPosition(),
          _n14 = ve(),
          _i19 = s + Math.floor((_e36 - (null === (t = J[0]) || void 0 === t ? void 0 : t.pos)) / _n14) * _n14;
        s = [_i19 + _n14, _i19, _i19 - _n14].reduce(function (t, n) {
          return Math.abs(n - _e36) < Math.abs(t - _e36) ? n : t;
        });
      }
      return s > i && s + n.dim < i + o ? 1 : s < i ? (s + n.dim - i) / n.dim : s + n.dim > i + o ? (i + o - s) / n.dim : 0;
    },
    getPages: function getPages() {
      return J;
    },
    getPlugins: function getPlugins() {
      return T;
    },
    getPosition: function getPosition(e) {
      var t;
      var n = q;
      if (H && !0 !== e) {
        var _e37 = ve();
        n -= Math.floor((q - (null === (t = J[0]) || void 0 === t ? void 0 : t.pos) || 0) / _e37) * _e37;
      }
      return n;
    },
    getSlides: function getSlides() {
      return G;
    },
    getState: function getState() {
      return L;
    },
    getTotalSlideDim: ve,
    getTween: function getTween() {
      return M;
    },
    getViewport: function getViewport() {
      return V;
    },
    getViewportDim: fe,
    getVisibleSlides: function getVisibleSlides(e) {
      return void 0 === e ? W : pe(e);
    },
    goTo: Oe,
    hasNavigated: function hasNavigated() {
      return void 0 !== j;
    },
    hideError: Le,
    hideLoading: Pe,
    init: function init() {
      if (!p || !t(p)) throw new Error("No Element found");
      return 0 !== L && (Re(), L = 0), R = p, A = x, window.removeEventListener("resize", ie), A.breakpoints && window.addEventListener("resize", ie), ie(), He;
    },
    isInfinite: function isInfinite() {
      return H;
    },
    isInTransition: function isInTransition() {
      return Y.size > 0;
    },
    isRTL: function isRTL() {
      return D;
    },
    isSettled: function isSettled() {
      return F;
    },
    isVertical: function isVertical() {
      return $;
    },
    localize: function localize(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return ee(e, t);
    },
    next: function next() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return Oe(I + 1, e), He;
    },
    off: function off(e, t) {
      var _iterator23 = _createForOfIteratorHelper(e instanceof Array ? e : [e]),
        _step23;
      try {
        for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
          var _n15 = _step23.value;
          te.has(_n15) && te.set(_n15, te.get(_n15).filter(function (e) {
            return e !== t;
          }));
        }
      } catch (err) {
        _iterator23.e(err);
      } finally {
        _iterator23.f();
      }
      return He;
    },
    on: function on(e, t) {
      var _iterator24 = _createForOfIteratorHelper(e instanceof Array ? e : [e]),
        _step24;
      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var _n16 = _step24.value;
          te.set(_n16, [].concat(_toConsumableArray(te.get(_n16) || []), [t]));
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
      return He;
    },
    prev: function prev() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return Oe(I - 1, e), He;
    },
    remove: function remove(e) {
      void 0 === e && (e = G.length - 1);
      var t = G[e];
      return t && (ne("removeSlide", t), t.el && (we(t.el), t.el.remove(), t.el = void 0), G.splice(e, 1), re(_), ye(), Te()), He;
    },
    setPosition: function setPosition(e) {
      q = e, le(), Te();
    },
    showError: function showError(e, t) {
      Pe(e), Le(e);
      var n = e.el;
      if (n) {
        var _i20 = document.createElement("div");
        c(_i20, "f-html"), c(_i20, "is-error"), _i20.innerHTML = ee(t || "<p>{{ERROR}}</p>"), e.htmlEl = _i20, c(n, "has-html"), c(n, "has-error"), n.insertAdjacentElement("afterbegin", _i20), ne("contentReady", e);
      }
      return He;
    },
    showLoading: function showLoading(e) {
      var t = e.el,
        n = null == t ? void 0 : t.querySelector(".f-spinner");
      if (!t || n) return He;
      var i = Z("spinnerTpl"),
        o = l(i);
      return o && (c(o, "f-spinner"), t.insertAdjacentElement("beforeend", o)), He;
    },
    version: "6.0.29"
  };
  return He;
};
_E.l10n = {
  en_EN: p
}, _E.getDefaults = function () {
  return m;
};
export { _E as Carousel };